import { Activity, Construction, ScanLine } from "lucide-react";
import { SectionEyebrow } from "@/components/Landing/primitives";

const PROBLEMS = Object.freeze([
    {
        id: "fragmented",
        title: "Fragmented systems on every project.",
        icon: Construction,
        body: "Different projects on different platforms. Spreadsheets fill the gaps. Group HSE has no consolidated view, and every new project is a fresh integration headache.",
    },
    {
        id: "manual-intake",
        title: "Manual reading at the intake desk.",
        icon: ScanLine,
        body: "Tickets, licences, white cards, medicals, and inductions uploaded to a file store \u2014 then read by eye, retyped into forms, and checked against role requirements by hand. The risk lands on the compliance officer.",
    },
    {
        id: "no-intelligence",
        title: "Capture without intelligence.",
        icon: Activity,
        body: "Capturing safety data is one problem. Knowing in real time which project is trending wrong, which contractor is dragging the scorecard down, or which critical control hasn't been verified this week \u2014 that's a different problem, and most platforms don't solve it.",
    },
]);

export default function Problem() {
    return (
        <section
            id="problem"
            className="relative py-24 sm:py-32 bg-[#0A0A0A] border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl reveal">
                    <SectionEyebrow>The problem</SectionEyebrow>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1] mt-3">
                        The first AI-native compliance platform built for Tier 1.
                    </h2>
                    <p className="mt-5 text-lg text-zinc-400">
                        Compliance has gone digital. It hasn't gone
                        intelligent. And it hasn't gone end-to-end.
                    </p>
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-5 lg:gap-6">
                    {PROBLEMS.map((c) => (
                        <article
                            key={c.id}
                            className="reveal lift rounded-2xl border border-white/10 bg-[#111827]/60 p-6 sm:p-7"
                        >
                            <c.icon className="w-7 h-7 text-[#1FA8FF]" />
                            <h3 className="mt-5 font-sora font-semibold text-xl text-white leading-tight">
                                {c.title}
                            </h3>
                            <p className="mt-3 text-[15px] text-zinc-400 leading-relaxed">
                                {c.body}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
